import type { FC } from "react";
import Button from "../../../Button";
import type { ButtonProps } from "../../../Button/Button";
import * as s from "./ShowAll.module.scss";

type ShowAllProps = Pick<ButtonProps, "label" | "onClick">;

const ShowAll: FC<ShowAllProps> = ({ label, onClick }) => {
	return (
		<Button
			className={s.showAll}
			variant="container"
			label={label ?? "Show all"}
			icon="arrow-right"
			onClick={onClick}
		/>
	);
};

export default ShowAll;
